import { Component, Input } from '@angular/core';

@Component({
	selector: 'highlighter',
	templateUrl: './highlighter.html'
})
export class Highlighter {

	public parts: { text: string, highlighted: boolean, $id: number }[] = [];

	private _text: string = '';
	private _serchText: string = '';
	private _highlight?: string;

	@Input() set text(value: string) { this._text = value; this._serchText = value.toLocaleLowerCase(); this.process(); }
	@Input() set highlight(value: string | undefined) { this._highlight = value?.toLocaleLowerCase(); this.process(); }

	private process() {
		if (!this._highlight) {
			this.parts = [{ text: this._text, highlighted: false, $id: 0 }];
			return;
		}

		const parts = [];
		let position = 0;
		let nextMatch = 0;
		let id = 0;
		while (nextMatch = this._serchText.indexOf(this._highlight, position), nextMatch >= 0) {
			parts.push({
				text: this._text.substring(position, nextMatch),
				highlighted: false,
				$id: id++
			});
			position = nextMatch + this._highlight.length
			parts.push({
				text: this._text.substring(nextMatch, position),
				highlighted: true,
				$id: id++
			});
		}
		if (position < this._text.length) {
			parts.push({
				text: this._text.substring(position),
				highlighted: false,
				$id: id++
			});
		}

		this.parts = parts;
	}
}
